import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ketto-assured',
  templateUrl: './ketto-assured.component.html',
  styleUrls: ['./ketto-assured.component.scss']
})
export class KettoAssuredComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  // assuredClickLisner(e) {
  //   const _el: HTMLElement = e.currentTarget.children[1];
  //   _el.classList.toggle('show-assured-popover');
  // }

}
